export default [
    {
        path: "/safety",
        name: "safety",
        component: () => import("./index"),
        meta: {
            permiss:['SAFETY_TASK_SHOW','SAFETY_POSITION_SHOW'],
            title: "安全打卡"
        }
    },
    {
        path: "/safety/task/:state/:id",
        name: "detail",
        component: () => import("./TaskDetail"),
        meta: {
            permiss:['SAFETY_TASK_SHOW'],
            title: "打卡点"
        }
    },
    {
        path: "/safety/task/:state/:id/:positionId",
        name: "detail",
        component: () => import("./TaskDetail"),
        meta: {
            permiss:['SAFETY_TASK_SHOW'],
            title: "打卡点"
        }
    },
    {
        path: "/safety/submit/:id",
        name: "submit",
        component: () => import("./Submit"),
        meta: {
            permiss:['SAFETY_TASK_HANDLE'],
            title: "提交打卡点"
        }
    },
    {
        path: "/safety/view/:id",
        name: "view",
        component: () => import("./Submit"),
        meta: {
            permiss:['SAFETY_TASK_HANDLE'],
            title: "查看打卡点详情"
        }
    },
    {
        path: "/safety/point/add",
        name: "add",
        component: () => import("./components/UpdateSafePoint"),
        meta: {
            permiss:['SAFETY_POSITION_ADD'],
            title: "创建打卡点"
        }
    },
    {
        path: "/safety/point/update/:id",
        name: "update",
        component: () => import("./components/UpdateSafePoint"),
        meta: {
            permiss:['SAFETY_POSITION_EDIT'],
            title: "修改打卡点"
        }
    },
]